module.exports = __webpack_public_path__ + "36f2d833626169946cbace8ddb628ce8.svg";